"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _decoration = require("@/api/decoration");
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'DecorationLead',
  data: function data() {
    return {
      listLoading: false,
      assignLoading: false,
      recycleLoading: false,
      assignVisible: false,
      currentLead: {},
      staffOptions: [],
      assignForm: {
        leadId: '',
        staffId: '',
        remark: ''
      },
      assignRules: {
        staffId: [{
          required: true,
          message: '请选择跟进职员',
          trigger: 'change'
        }]
      },
      dateRange: [],
      searchForm: {
        page: 1,
        limit: this.$constants.page.limit[0],
        keywords: '',
        status: '',
        sourceType: '',
        platformSyncStatus: '',
        startDate: '',
        endDate: ''
      },
      tableData: {
        data: [],
        total: 0
      },
      statusOptions: [{
        label: '待分配',
        value: 'unassigned'
      }, {
        label: '待跟进',
        value: 'following'
      }, {
        label: '待量房',
        value: 'measuring'
      }, {
        label: '待方案报价',
        value: 'quoting'
      }, {
        label: '待签设计合同',
        value: 'design_contract_pending'
      }, {
        label: '预约不成功',
        value: 'appointment_failed'
      }, {
        label: '已转客户',
        value: 'converted'
      }, {
        label: '公海',
        value: 'public_pool'
      }, {
        label: '无效',
        value: 'invalid'
      }, {
        label: '已死单',
        value: 'lost'
      }],
      statusText: {
        unassigned: '待分配',
        following: '待跟进',
        measuring: '待量房',
        quoting: '待方案报价',
        design_contract_pending: '待签设计合同',
        appointment_failed: '预约不成功',
        converted: '已转客户',
        public_pool: '公海',
        invalid: '无效',
        lost: '已死单'
      },
      statusTagType: {
        unassigned: 'warning',
        following: '',
        measuring: '',
        quoting: '',
        design_contract_pending: '',
        appointment_failed: 'danger',
        converted: 'success',
        public_pool: 'info',
        invalid: 'info',
        lost: 'danger'
      },
      houseTypeText: {
        new: '新房',
        old: '老房'
      },
      sourcePageText: {
        home_quote: '首页报价'
      },
      sourceTypeText: {
        ad: '投流',
        ecommerce: '电商',
        employee: '员工自有',
        public_pool: '公海',
        other: '其他'
      },
      platformSyncText: {
        platform_pending: '待对接',
        synced: '已同步',
        failed: '同步失败'
      },
      platformSyncTag: {
        platform_pending: 'warning',
        synced: 'success',
        failed: 'danger'
      },
      platformSyncOptions: [{
        label: '待对接',
        value: 'platform_pending'
      }, {
        label: '已同步',
        value: 'synced'
      }, {
        label: '同步失败',
        value: 'failed'
      }],
      sourceTypeOptions: [{
        label: '投流',
        value: 'ad'
      }, {
        label: '电商',
        value: 'ecommerce'
      }, {
        label: '员工自有',
        value: 'employee'
      }, {
        label: '公海',
        value: 'public_pool'
      }, {
        label: '其他',
        value: 'other'
      }],
      quoteStatusText: {
        draft: '草稿',
        submitted: '已提交'
      },
      contractStatusText: {
        draft: '草稿',
        pending_signature: '待签署',
        effective: '已生效'
      },
      contractTagType: {
        draft: 'warning',
        pending_signature: '',
        effective: 'success'
      },
      jobTypeText: {
        owner: '负责人',
        business: '业务',
        customer_service: '客服',
        designer: '设计师'
      }
    };
  },
  created: function created() {
    this.getList();
  },
  methods: {
    formatMoney: function formatMoney(value) {
      return Number(value || 0).toFixed(2);
    },
    getList: function getList() {
      var _this = this;
      this.listLoading = true;
      (0, _decoration.decorationLeadListApi)(this.searchForm).then(function (res) {
        _this.tableData.data = res.list || [];
        _this.tableData.total = res.total || 0;
      }).finally(function () {
        _this.listLoading = false;
      });
    },
    handleSearch: function handleSearch() {
      this.searchForm.page = 1;
      this.getList();
    },
    handleReset: function handleReset() {
      this.dateRange = [];
      this.searchForm = {
        page: 1,
        limit: this.searchForm.limit,
        keywords: '',
        status: '',
        sourceType: '',
        platformSyncStatus: '',
        startDate: '',
        endDate: ''
      };
      this.getList();
    },
    recycleStale: function () {
      var _recycleStale = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var count, _t, _t2;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              _context.n = 1;
              return this.$confirm('将回收跟进超时或截止超时的线索到公海，是否继续？', '公海回收', {
                type: 'warning'
              });
            case 1:
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              return _context.a(2);
            case 3:
              this.recycleLoading = true;
              _context.p = 4;
              _context.n = 5;
              return (0, _decoration.decorationLeadRecycleStaleApi)({
                staleFollowDays: 7
              });
            case 5:
              count = _context.v;
              this.$message.success("\u5DF2\u56DE\u6536 ".concat(count || 0, " \u6761\u7EBF\u7D22\u5230\u516C\u6D77"));
              this.getList();
              _context.n = 7;
              break;
            case 6:
              _context.p = 6;
              _t2 = _context.v;
              this.$message.error(_t2 && _t2.message || '公海回收失败');
            case 7:
              _context.p = 7;
              this.recycleLoading = false;
              return _context.f(7);
            case 8:
              return _context.a(2);
          }
        }, _callee, this, [[4, 6, 7, 8], [0, 2]]);
      }));
      function recycleStale() {
        return _recycleStale.apply(this, arguments);
      }
      return recycleStale;
    }(),
    handleDateChange: function handleDateChange(value) {
      this.searchForm.startDate = value && value.length ? value[0] : '';
      this.searchForm.endDate = value && value.length ? value[1] : '';
      this.handleSearch();
    },
    handleSizeChange: function handleSizeChange(value) {
      this.searchForm.limit = value;
      this.searchForm.page = 1;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(value) {
      this.searchForm.page = value;
      this.getList();
    },
    openAssign: function () {
      var _openAssign = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(row) {
        var _t3;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              this.currentLead = row;
              this.assignForm.leadId = row.id;
              _context2.p = 1;
              _context2.n = 2;
              return (0, _decoration.decorationLeadStaffOptionsApi)();
            case 2:
              this.staffOptions = _context2.v;
              if (this.staffOptions.length) {
                _context2.n = 3;
                break;
              }
              this.$message.warning('当前装企暂无可分配职员');
              return _context2.a(2);
            case 3:
              this.assignVisible = true;
              _context2.n = 5;
              break;
            case 4:
              _context2.p = 4;
              _t3 = _context2.v;
              this.$message.error(_t3 && _t3.message || '职员列表加载失败');
            case 5:
              return _context2.a(2);
          }
        }, _callee2, this, [[1, 4]]);
      }));
      function openAssign(_x) {
        return _openAssign.apply(this, arguments);
      }
      return openAssign;
    }(),
    submitAssign: function submitAssign() {
      var _this2 = this;
      this.$refs.assignForm.validate(/*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(valid) {
          var _t4;
          return _regenerator().w(function (_context3) {
            while (1) switch (_context3.p = _context3.n) {
              case 0:
                if (valid) {
                  _context3.n = 1;
                  break;
                }
                return _context3.a(2);
              case 1:
                _this2.assignLoading = true;
                _context3.p = 2;
                _context3.n = 3;
                return (0, _decoration.decorationLeadAssignApi)(_this2.assignForm);
              case 3:
                _this2.$message.success('分配成功，线索已进入待跟进');
                _this2.assignVisible = false;
                _this2.getList();
                _context3.n = 5;
                break;
              case 4:
                _context3.p = 4;
                _t4 = _context3.v;
                _this2.$message.error(_t4 && _t4.message || '分配失败');
              case 5:
                _context3.p = 5;
                _this2.assignLoading = false;
                return _context3.f(5);
              case 6:
                return _context3.a(2);
            }
          }, _callee3, null, [[2, 4, 5, 6]]);
        }));
        return function (_x2) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    resetAssign: function resetAssign() {
      this.currentLead = {};
      this.staffOptions = [];
      this.assignForm = {
        leadId: '',
        staffId: '',
        remark: ''
      };
      if (this.$refs.assignForm) this.$refs.assignForm.clearValidate();
    }
  }
};